import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserInfo } from '../interfaces/userInfo';
import { BaseHttpService } from './base-http.service';

@Injectable({
	providedIn: 'root'
})
export class UserService extends BaseHttpService {
	getUserInfo(): Observable<UserInfo> {
		const URL = `${environment.BUVApiUrl}/api/buv/getUserInfo`;
		return this.http.get<UserInfo>(URL);
	}

	createVecino(payload: any): Observable<any> {
		const URL = `${environment.BUVApiUrl}/api/buv`;
		return this.http.post<any>(URL, this.mapVecinoPayload(payload));
	}

	updateVecino(id: string, payload: any): Observable<any> {
		const URL = `${environment.BUVApiUrl}/api/buv/${id}`;
		return this.http.put<any>(URL, this.mapVecinoPayload(payload));
	}

	resetPassword(idVecino: string): Observable<any> {
		const URL = `${environment.BUVApiUrl}/api/buv/reset-password`;
		const body = {
			idVecino: Number(idVecino)
		};
		return this.http.post<any>(URL, body);
	}

	private mapVecinoPayload(payload: any): any {
		const GENERO_MAP: Record<string, string> = {
			Masculino: 'M',
			Femenino: 'F',
			Otro: 'X'
		};
		const sexo = GENERO_MAP[payload.sexo] ?? payload.sexo;
		const genero = sexo;

		const nacionalidad = payload.nacionalidad;

		const cuil = payload.cuil || payload.username;

		return {
			...payload,
			sexo,
			genero,
			nacionalidad,
			cuil,
			plataforma: 'IdentidadDigital'
		};
	}
}
